<template>
    <div>
        <el-alert :title="tip.title" :type="tip.type" :description="tip.description"/>
    </div>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, inject, watch } from 'vue'
    export default defineComponent({
        props: {
            tip: {
                type: [Array, Object],
                default: () => {}
            }
        }
    })
</script>

<style scoped>

</style>
